module.exports = "/_next/static/images/harajuku_lunch_cheese-190f3d3d42487a88d379976b4148e43b.jpg";